import React, { useState, useRef, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { IoIosKeypad } from "react-icons/io";
import { withTranslation } from "react-i18next";
import { TOKEN_KEY } from "../../helpers/url_helper";
import { shuffleArray, handleNumberInput, pinStatusCheck, NUMBERS, MAX_PIN_LENGTH } from "../../helpers/pinHelpers";
import { makeAjax, respStatus, showMessage, url, handleLogout } from "../../helpers/global_helper";

const RegisterPin = (props) => {
  const [newPinFirstTime, setNewPinFirstTime] = useState(true);
  const [confirmPinFirstTime, setConfirmPinFirstTime] = useState(true);
  const [activeKeypad, setActiveKeypad] = useState(null);
  const [newPin, setNewPin] = useState("");
  const [confirmPin, setConfirmPin] = useState("");
  const [numbers, setNumbers] = useState([]);
  const keypadRef = useRef(null);
  const navigate = useNavigate();

  useEffect(() => {
    setNumbers(shuffleArray(NUMBERS));
    pinStatusCheck(navigate);
  }, []);

  const handleClick = (type) => {
    setActiveKeypad(type);

    // if (type === "newPin") {
    //   setNewPin("");
    // }

    // if (type === "confirmPin") {
    //   setConfirmPin("");
    // }
  };

  const handleClose = () => {
    setActiveKeypad(null);
  };

  const validatePin = (pin, onClose, onClear) => {
    if (pin.length < 6) {
      showMessage("PIN must be exactly 6 digits long");
      return false;
    }

    const isWeak = pin.split("").every(digit => digit === pin[0]);

    if (isWeak) {
      showMessage(props.t("pin_not_same"));
      return false;
    }

    return true;
  };


  const handleNumberClickForNewPin = (num) => {
    setNewPin((prev) => handleNumberInput(prev, num, MAX_PIN_LENGTH));
  };

  const handleNumberClickForConfirmPin = (num) => {
    setConfirmPin((prev) => handleNumberInput(prev, num, MAX_PIN_LENGTH));
  };

  const handleClearNewPin = () => setNewPin("");
  const handleClearConfirmPin = () => setConfirmPin("");
  const handleDeleteNewPin = () => setNewPin(prev => prev.slice(0, -1));
  const handleDeleteConfirmPin = () => setConfirmPin(prev => prev.slice(0, -1));


  const validatePinMatch = () => {
    if (newPin !== confirmPin) {
      console.warn("PIN mismatch: New PIN and confirm PIN do not match");
      showMessage(props.t("pin_mismatch"));
      setNewPin("");
      setConfirmPin("");
      return false;
    }
    return true;
  };

  const handleSubmit = async () => {
    if (!validatePinMatch()) {
      return;
    }

    const response = await makeAjax(url.PLAYER_API.setPin, { pin: newPin }, url.PLAYER_MS_EXT);
    if (response?.status !== respStatus.SUCCESS) {

      showMessage(response);
      return;
    }
    if (response?.data?.pinSet === true) {
      localStorage.setItem("__ps", null);
      navigate("/");
    }
    else if (response.data.pinSet === false) {
      console.warn(response.messages);

      showMessage(response.data.message);
    }
  };

  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (keypadRef.current && !keypadRef.current.contains(event.target)) {
        setActiveKeypad(null);
      }
    };

    if (activeKeypad) {
      document.addEventListener("mousedown", handleOutsideClick);
    }

    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, [activeKeypad]);



  return (
    <>
      <div className="pin-container">
        <div className="register-pin">
          <div className="pin-heading">
            <div className="welcome">
              <p>{props.t('welcome')}</p>
              <p className="username">{localStorage.getItem("nickname")}</p>
            </div>
            <div className="header-title">{props.t('security_validation')}</div>
          </div>

          <div className="inner-content">
            <p className="title">{props.t('create_new_pin')}</p>
            <p className="pin-subtitle">
              {props.t('pin_purpose')}
            </p>

            <div className="outer-keypad">
              <p>
                {props.t('random_buttons_notice')}
              </p>

              <div className="register keypad-first pb-2">
                <div className="pin-name">
                  {/* {props.t('enter')} <span>{props.t('your_new')}</span>{props.t('pin')}   */}
                  {props.t('enter_new_pin')}
                </div>

                <div className="top-bar">
                  <div
                    className="search-box"
                    onClick={() => handleClick("newPin")}
                  >
                    <input type="password" value={newPin} readOnly placeholder={props.t("enter_pin")} />
                    <span className="grid-icon">
                      <IoIosKeypad />
                    </span>
                  </div>
                </div>

                {activeKeypad === "newPin" && (
                  <div className="keypad-wrapper" ref={keypadRef}>
                    <Keypad
                      numbers={numbers}
                      pin={newPin}
                      type="newPin"
                      firstTime={newPinFirstTime}
                      setFirstTime={setNewPinFirstTime}
                      validatePin={validatePin}
                      onNumberClick={handleNumberClickForNewPin}
                      onClear={handleClearNewPin}
                      onDelete={handleDeleteNewPin}
                      onClose={handleClose}
                      t={props.t}
                    />
                  </div>
                )}
              </div>

              <div className="keypad-second pb-2">
                <div className="pin-name">
                  {/* {props.t('confirm ')} <span>{props.t('your_new')}</span>{props.t('pin')} */}
                  {props.t('confirm_new_pin')}
                </div>

                <div className="top-bar">
                  <div
                    className="search-box"
                    onClick={() => handleClick("confirmPin")}
                  >
                    <input type="password" value={confirmPin} readOnly placeholder={props.t("enter_pin")} />
                    <span className="grid-icon">
                      <IoIosKeypad />
                    </span>
                  </div>
                </div>

                {activeKeypad === "confirmPin" && (
                  <div className="keypad-wrapper" ref={keypadRef}>
                    <Keypad
                      numbers={numbers}
                      pin={confirmPin}
                      type="confirmPin"
                      firstTime={confirmPinFirstTime}
                      setFirstTime={setConfirmPinFirstTime}
                      validatePin={validatePin}
                      onNumberClick={handleNumberClickForConfirmPin}
                      onClear={handleClearConfirmPin}
                      onDelete={handleDeleteConfirmPin}
                      onClose={handleClose}
                      t={props.t}
                    />
                  </div>
                )}
              </div>

              <div className="actions-process">
                <div className="btn-green" onClick={handleSubmit}>{props.t('process')}</div>
                <button className="btn-red" onClick={() => handleLogout(TOKEN_KEY)}>{props.t('logout')}</button>
              </div>

              <div className="footer-note" style={{ color: "#EAFF00" }}>
                {props.t('pin_usage')}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};


const Keypad = ({ numbers, pin, type, firstTime, setFirstTime, validatePin, onNumberClick, onClear, onDelete, onClose, t }) => {

  useEffect(() => {
    if (pin.length === 6) {
      const timer = setTimeout(() => handleProcess(pin), 200);
      return () => clearTimeout(timer);
    }
  }, [pin]);

  const handleProcess = () => {
    if (!validatePin(pin)) {
      onClose();
      onClear();
      return;
    }

    if (firstTime && pin.length === 6) {
      setFirstTime(false);
      onClose();
      return;
    }
  };

  return (

    <div className="keypad-body">
      <div className="numbers">
        {numbers.slice(0, 9).map((num, index) => (
          <button
            key={index}
            type="button"
            onClick={() => onNumberClick(num)}
          >
            {num}
          </button>
        ))}
        <button
          className="last"
          type="button"
          onClick={() => onNumberClick(numbers[9])}
        >
          {numbers[9]}
        </button>
      </div>

      <div className="actions">
        <button className="process" type="button"
          onClick={() => { handleProcess(pin); onClose(); }}
          disabled={pin.length !== 6}>
          {t('process')}
        </button>
        <button className="delete" type="button" onClick={onDelete}>
          {t('delete')}
        </button>
        <button className="close-btn" type="button" onClick={onClose}>
          {t('close')}
        </button>
      </div>
    </div>
  );
};

export default withTranslation()(RegisterPin);